// extracted by mini-css-extract-plugin
module.exports = {"next_image":"next-image_next_image__F_FEO"};